// Gentle fade-up reveal for content sections as they enter the viewport.
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const sections = document.querySelectorAll(
    '.shopify-section:not([class*="section-group"])'
  );
  if (!sections.length || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pm-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.06, rootMargin: '0px 0px -6% 0px' }
  );

  // This script is deferred, so it runs after first paint. Adding the
  // opacity:0 class to something already on screen makes it visibly blink out
  // and fade back in. Anything within the initial viewport is therefore left
  // alone — only content below the fold animates in.
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  sections.forEach(function (el, i) {
    // Leave the hero (first section) untouched so it's instant.
    if (i === 0) return;
    if (el.getBoundingClientRect().top < viewportHeight) return;
    // The moving marquee should be visible immediately, not fade in on scroll.
    if (el.querySelector('.pm-marquee')) return;
    // The popup is a fixed overlay — a transform on its section would trap it
    // in a containing block and render it in-flow behind the footer.
    if (el.querySelector('[data-pm-popup]')) return;
    el.classList.add('pm-reveal');
    observer.observe(el);
  });
})();
